import React, { useState } from 'react';
import './BookRide.css';

function BookRide() {
  const [form, setForm] = useState({ name: '', email: '', phone: '' });

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    // hook up to your booking endpoint here
  };

  return (
    <section className="bookride">
      <div className="bookride__left">
        <span className="bookride__eyebrow">FEEL THE POWER</span>
        <h2 className="bookride__heading">
          Experience The<br />
          Thrill Firsthand
        </h2>
        <p className="bookride__text">
          Book your free test ride now and feel the power of Acriolis ATVs in action!
        </p>
      </div>

      <form className="bookride__form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          value={form.name}
          onChange={handleChange}
          className="bookride__input"
        />
        <input
          type="email"
          name="email"
          placeholder="Email Address"
          value={form.email}
          onChange={handleChange}
          className="bookride__input"
        />
        <input
          type="tel"
          name="phone"
          placeholder="Phone Number"
          value={form.phone}
          onChange={handleChange}
          className="bookride__input"
        />
        <button type="submit" className="bookride__btn">
          Book Test Ride <span>→</span>
        </button>
      </form>

      <div
        className="bookride__image"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/cta-defence.png)` }}
        aria-label="Rider on Acriolis ATV"
      />
    </section>
  );
}

export default BookRide;
